import type { SVGProps } from 'react';
const SvgControlCamera = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#control_camera_svg__a)">
      <path d="M15.54 5.54 13.77 7.3 12 5.54 10.23 7.3 8.46 5.54 12 2l3.54 3.54Zm2.92 10-1.76-1.77L18.46 12l-1.76-1.77 1.76-1.77L22 12l-3.54 3.54Zm-10 2.92 1.77-1.76L12 18.46l1.77-1.76 1.77 1.76L12 22l-3.54-3.54Zm-2.92-10 1.76 1.77L5.54 12l1.76 1.77-1.76 1.77L2 12l3.54-3.54ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
    </g>
    <defs>
      <clipPath id="control_camera_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgControlCamera;
